import { defineStore } from "pinia";
import type { Admin } from "server/types";

export const useAdminStore = defineStore("admin", () => {
  const admin = ref<Admin>({} as Admin);
  const isAdminLoggedIn = computed(() => !!admin.value.user_id);
  const adminApiPath = ref<string>("");

  function setAdmin(data: Admin = {} as Admin) {
    admin.value = data;
  }

  function setPath(path: string) {
    adminApiPath.value = path;
  }

  async function fetchAdmin(force = false) {
    if (admin.value.user_id && !force) return;

    if (!adminApiPath.value) {
      await fetchApiPath();
    }
    try {
      const { data } = await get<Record<string, Admin>>(`${adminApiPath.value}/info`);
      setAdmin(data);
    } catch (e) {
      console.error("failed to fetch admin:", e);
    }
  }

  async function fetchApiPath() {
    try {
      const res = await get<{ path: string }>("auth/internal/path");
      setPath(res.path);
    } catch (e) {
      console.error("failed to fetch admin api path:", e);
    }
  }

  async function logout() {
    await post(`${adminApiPath.value}/logout`);
    setAdmin();
    window.location.href = "/internal/ops/" + import.meta.env.VITE_ADMIN_HASH + "/ops-login";
  }

  function setAdminApiPath(path: string) {
    adminApiPath.value = path;
  }

  return {
    admin,
    setAdmin,
    isAdminLoggedIn,
    adminApiPath,
    logout,
    fetchAdmin,
    setAdminApiPath,
  };
});
